import api from './api';

export const channelPartnerService = {
    // Get all channel partners
    getAllChannelPartners: (params) => api.get('/channel-partners', { params }),

    // Get channel partner by ID
    getChannelPartnerById: (id) => api.get(`/channel-partners/${id}`),

    // Create channel partner
    createChannelPartner: (partnerData) => api.post('/channel-partners', partnerData),

    // Update channel partner
    updateChannelPartner: (id, partnerData) => api.put(`/channel-partners/${id}`, partnerData),

    // Delete channel partner
    deleteChannelPartner: (id) => api.delete(`/channel-partners/${id}`)
};
